import { call, put, takeLatest } from 'redux-saga/effects';
import { tutorialVideosService } from './tutorialVideos.service';
import {
    CREATE_TUTORIAL_VIDEO,
    DELETE_TUTORIAL_VIDEO,
    EDIT_TUTORIAL_VIDEO,
    GET_TUTORIAL_VIDEOS,
    GET_TUTORIAL_VIDEOS_SUCCESS,
} from './tutorialVideos.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getTutorialVideos({ type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(tutorialVideosService.getTutorialVideosService);
        yield put({
            type: GET_TUTORIAL_VIDEOS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/**
 * Create / edit / delete all re-fetch the list rather than patching it
 * locally: the response carries freshly signed URLs and the api decides
 * the merged ordering of platform and org videos, so re-reading is the
 * only way the client stays honest about both.
 */
function* createTutorialVideo({ type, payload }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(tutorialVideosService.createTutorialVideoService, payload.body);
        yield put({ type: GET_TUTORIAL_VIDEOS });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editTutorialVideo({ type, payload }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(tutorialVideosService.editTutorialVideoService, payload.id, payload.body);
        yield put({ type: GET_TUTORIAL_VIDEOS });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deleteTutorialVideo({ type, payload }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(tutorialVideosService.deleteTutorialVideoService, payload.id);
        yield put({ type: GET_TUTORIAL_VIDEOS });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchTutorialVideos = function* watchTutorialVideosSaga() {
    yield takeLatest(GET_TUTORIAL_VIDEOS, getTutorialVideos);
    yield takeLatest(CREATE_TUTORIAL_VIDEO, createTutorialVideo);
    yield takeLatest(EDIT_TUTORIAL_VIDEO, editTutorialVideo);
    yield takeLatest(DELETE_TUTORIAL_VIDEO, deleteTutorialVideo);
};
